'use client';

import { useState, useRef, ReactNode } from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { clsx } from 'clsx';
import { SvgStar } from '../icons';
import OpenArrowSvg from '@/assets/icons/open.svg';
import DefaultService from '@/assets/icons/defaulte_services.svg';
import DefaultAnalyzes from '@/assets/icons/defaulte_analyzes.svg';
import { API_STATIC_FILES } from '@/utils/constants';
import type { AccordionProps, DefaultIcon, TGroup } from './accordion.types';
import s from './accordion.module.scss';

const defaultIconMap: Record<DefaultIcon, ReactNode> = {
  services: <DefaultService />,
  analyses: <DefaultAnalyzes />,
};

export const Accordion = <T extends TGroup, >(props: AccordionProps<T>) => {
  const {
    category_name,
    description,
    category_icon,
    groups,
    categorySlug,
    defaultIcon,
  } = props;
  const [isOpen, setIsOpen] = useState(false);
  const groupsRef = useRef<HTMLUListElement | null>(null);
  const icon = `${API_STATIC_FILES}${category_icon}`;

  return (
    <li>
      <div className={s.questionContainer}>
        <div className={s.questionContainer__head} onClick={() => setIsOpen(!isOpen)}>
          <div className={s.titleContainer}>
            <div className={s.titleIconContainer}>
              {category_icon ? (
                <Image
                  src={icon}
                  alt="Иконка для медицинской категории"
                  width={34}
                  height={56}
                />
              ) : defaultIconMap[defaultIcon]}
              <h2 className={s.title}>
                {category_name}
              </h2>
            </div>
            <div className={clsx(s.arrow, { [s.arrow__opened]: isOpen })}>
              <OpenArrowSvg />
            </div>
          </div>
          {description && <div className={s.description} dangerouslySetInnerHTML={{ __html: description || '' }} />}
        </div>
      </div>
      <div
        className={s.collapseBlock}
        style={{ height: isOpen ? groupsRef.current?.scrollHeight : '0px' }}
      >
        <ul ref={groupsRef} className={s.list}>
          {groups?.map((item) => {
            return (
              <li key={item.id} className={s.list__item}>
                <Link
                  className={s.list__link}
                  href={`/${categorySlug || 'services'}/${item.id}`}
                >
                  {item.group_name}
                  <div className={s.list__hoverIcon}>
                    <SvgStar />
                  </div>
                </Link>
              </li>
            );
          })}
        </ul>
      </div>
    </li>
  );
};